import React, { useState, useEffect } from "react";
import { get, post } from "../../utils/HttpRequest";
import config from "../../config/config.json";
import Header from "../Header/Header";
import { Row, Col, Container, Card } from "react-bootstrap";
import MediaFrame from "./MediaFrame";
import Sidebar from "./Sidebar";
import LessonHeader from "./LessonHeader";
import AssessmentProgressBar from "../Lessonview/AssessmentProgressBar";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import "./Lessonviewmobile.css";

const LessonviewMobile = () => {
  const search = window.location.search;
  const navigate = useNavigate();
  const params = new URLSearchParams(search);
  const lessonid = params.get("lessonid");
  var topicid = params.get("topicid");
  var parentids = params.get("parentids");
  var parentNames = params.get("parentNames");
  var [selectedLanguage, setSelectedLanguage] = useState(
    params.get("language")
  );
  var [lessonData, setlessonData] = useState(null);
  var [topicToLoad, settopicToLoad] = useState(null);
  // const [lessonurl, setlessonurl] = useState(null);
  var [toggleHeader, setToggleHeader] = useState(true);
  var [isAssessment, setIsAssessment] = useState(false);
  var [notTopicsDialogVisible, setNoTopicsDialogVisible] = useState(false);
  var [otherRoleReviewFlag, setOtherRoleReviewFlag] = useState(false);
  var [retakeFlag, setRetakeFlag] = useState(false);
  var [ackFlag, setAckFlag] = useState(false);
  var [retakeDialogVisible, setRetakeDialogVisible] = useState(false);
  var [isRetakeClicked, setIsRetakeClicked] = useState(false);
  
  // BREADCRUMB STATE VARIABLES
  var [parentLessonNames, setparentLessonNames] = useState([]);
  var [parentLessonIds, setparentLessonIds] = useState([]);
  var [isTrialDUser, setIsTrialDUser] = useState(false);

  var [maxAttemptsAssessment, setMaxAttemptsAssessment] = useState(5);
  var [maxAttemptsAssessmentMessage, setMaxAttemptsAssessmentMessage] = useState("");
  var [maxAttemptLimitReached, setMaxAttemptLimitReached] = useState(false);

  // Feeds the assessment progress bar: latest record drives the score/result,
  // the full list drives the attempt history and "attempts used" count.
  var [latestCompletionRecord, setLatestCompletionRecord] = useState(null);
  var [allCompletionRecords, setAllCompletionRecords] = useState([]);

  const handleToggleHeader = () => {
    setToggleHeader((prev) => !prev);
  };

  // INITIALIZE BREADCRUMB
  useEffect(() => {
    if (parentNames !== null && parentids !== null) {
      setparentLessonNames(parentNames.split("|").filter((n) => n));
      setparentLessonIds(parentids.split("|").filter((n) => n));
    } else {
      setparentLessonNames([]);
      setparentLessonIds([]);
    }
  }, [parentNames, parentids]);

  const loadLessondata = (lessonurl, topicid) => {
    localStorage.removeItem("lessonid");
    localStorage.removeItem("topicid");

    post(lessonurl).then(async (response) => {
      const lesson = response.data.getLessonandTopicsFuncResponse;

      // Most recent completion record first (largest addedEpoch)
      const completionRecords =
        response.data.getCompletionRecordsForUserResponse ?? [];
      if (completionRecords.length > 0) {
        const sorted = [...completionRecords].sort(
          (a, b) => b.addedEpoch - a.addedEpoch
        );
        setLatestCompletionRecord(sorted[0]);
        setAllCompletionRecords(sorted);
      } else {
        setLatestCompletionRecord(null);
        setAllCompletionRecords([]);
      }

      let topicToPass = null;
      // var topicViewedCounts = {};
      if (
        localStorage.getItem("userRole") != null &&
        localStorage.getItem("userRole").toLowerCase() == "cro"
      ) {
        let url = config.api.url + "getTrialConfig/croLessonReview";
        await get(url)
          .then((result) => {
            let sponsorLessonReview = result.data;
            if (sponsorLessonReview.value == true) {
              // hide review tile from topmenubar
              setOtherRoleReviewFlag(true);
            }
          })
          .catch((err) => {
            console.log("Error getting croLessonReview data.", err);
          });
      } else if (
        localStorage.getItem("userRole") != null &&
        localStorage.getItem("userRole").toLowerCase() == "sponsor"
      ) {
        let url = config.api.url + "getTrialConfig/sponsorLessonReview";
        await get(url)
          .then((result) => {
            let sponsorLessonReview = result.data;
            if (sponsorLessonReview.value == true) {
              // hide review tile from topmenubar
              setOtherRoleReviewFlag(true);
            }
          })
          .catch((err) => {
            console.log("Error getting sponsorLessonReview data.", err);
          });
      }

      if (
        lesson.lessondetails.status == "active" ||
        otherRoleReviewFlag ||
        (localStorage.getItem("userRole") != null &&
          localStorage.getItem("userRole").toLowerCase() == "smiadmin")
      ) {
        if (lesson && lesson.topics && lesson.topics.length == 0) {
          setNoTopicsDialogVisible(true);
          settopicToLoad({});
          setlessonData(response.data.getTopicsViewedByUserFuncResponse);
        } else {
          if (lesson.topics.length > 0) {
            let tempTopic = lesson.topics.find(
              (t) =>
                t.topic_id ===
                response.data.getTopicDetailsFuncResponse.topic_id
            );
            topicToPass = response.data.getTopicDetailsFuncResponse;
            if (tempTopic && tempTopic["topicfolder"]) {
              topicToPass["topicfolder"] = tempTopic["topicfolder"];
            }
            localStorage.setItem("topicid", topicToPass.topic_id);
            setNoTopicsDialogVisible(false);
          } else {
            setNoTopicsDialogVisible(true);
          }
          if (
            !selectedLanguage &&
            localStorage.getItem("userLanguage") &&
            topicToPass.language
          ) {
            let topicLanguage = topicToPass.language
              .split(",")
              .map((x) => x.trim());
            if (
              topicLanguage.indexOf(localStorage.getItem("userLanguage")) !=
              -1 &&
              localStorage.getItem("userLanguage") != "English"
            ) {
              setSelectedLanguage(localStorage.getItem("userLanguage"));
            } else {
              setSelectedLanguage("English");
            }
          } else {
            let topicLanguage = topicToPass?.language
              ?.split(",")
              .map((x) => x.trim());
            if (
              selectedLanguage !== "" &&
              topicLanguage &&
              topicLanguage.indexOf(selectedLanguage) != -1 &&
              selectedLanguage !== "English"
            ) {
              setSelectedLanguage(selectedLanguage);
            } else {
              setSelectedLanguage("English");
            }
          }
          let topicViewedCounts = {};
          let viewedLessonData =
            response.data.getTopicsViewedByUserFuncResponse;
          if (
            response.data.getTopicsViewedByUserFuncResponse &&
            viewedLessonData.topics &&
            viewedLessonData.topics.length > 0
          ) {


            //Jun-28-2025 : Hiren : Fix for last topic had to be clicked twice for acknowledge button to show
            // Skip for assessments: there "viewed" means "answered", so marking the newly
            // loaded question as viewed made the last question get skipped (redirect to acknowledge).
            if (viewedLessonData.lessondetails?.lessontype !== "assessment") {
              viewedLessonData.topics = viewedLessonData.topics.map(o=> {
                if(o.topic_id==topicid){
                    console.log("current topicID is: "+topicid);
                  return { ...o,
                        topicviewed: true
                      };
                }
                return o;
              })
            }

            
            viewedLessonData.topics.forEach((value) => {
              topicViewedCounts[value.topicviewed] =
                (topicViewedCounts[value.topicviewed] || 0) + 1;
              if (selectedLanguage) {
                value.selectedLanguage = selectedLanguage;
              }
            });
          }
          if (!topicViewedCounts.false) {
            if (
              topicToPass &&
              viewedLessonData.lessondetails.lessontype === "assessment"
            ) {
              setIsAssessment(true);
              setMaxAttemptLimitReached(false);
              if (viewedLessonData.lessondetails.lessonComplete == "true") {
                // show retake button / UI from here
                try {
                  try {
                    const res1 = await get(config.api.url + "getTrialConfig/noOfMaxAttemptsAllowedForAssessment");
                    const res2 = await get(config.api.url + "getTrialConfig/messageForAssessmentScoreThreshold");

                    if (res1?.data?.value) setMaxAttemptsAssessment(res1.data.value);
                    if (res2?.data?.value) setMaxAttemptsAssessmentMessage(res2.data.value);

                    if (response.data && response.data.getCompletionRecordsForUserResponse.length > 0) {
                      if (response.data.getCompletionRecordsForUserResponse.length >= parseInt(res1.data.value)) {
                        var allLessonArchievedCount = 0;
                        response.data.getCompletionRecordsForUserResponse.forEach(lesson => {
                          if (lesson && lesson.logid.startsWith('archive-')) {
                            allLessonArchievedCount += 1;
                          }
                        })
                        console.log('allLessonArchievedCount', allLessonArchievedCount)

                        if (allLessonArchievedCount == response.data.getCompletionRecordsForUserResponse.length) {
                          setRetakeFlag(true);
                          setMaxAttemptLimitReached(false);
                        } else {
                          setMaxAttemptLimitReached(true);
                        }
                      } else {
                        setRetakeFlag(true);
                      }
                    } else {
                      setRetakeFlag(true);
                    }
                  } catch (err) {
                    console.error("Error getting data.", err);
                  }
                } catch (err) {
                  console.log("Error handling max Attempt for assessment :: ", err)
                  setRetakeFlag(true);
                }
              } else if (
                viewedLessonData.lessondetails.lessonComplete == "false"
              ) {
                const url =
                  "/acknowledge?lessonid=" +
                  viewedLessonData.lessondetails.lessonid;
                navigate(url);
              }
            } else if (viewedLessonData.lessondetails.status == "review") {
              // hide acknowledge button in topmenu bar
              setAckFlag(false);
            } else if (
              viewedLessonData.lessondetails.lessonComplete == "false" &&
              viewedLessonData.lessondetails.acknowledgementRequired &&
              viewedLessonData.lessondetails.acknowledgementRequired != "no"
            ) {
              // show acknowledge button in topmenu bar
              setAckFlag(true);
            }
          } else {
            if (
              topicToPass &&
              lesson.lessondetails.lessontype === "assessment"
            ) {
              setIsAssessment(true);
              let obj = [];
              Object.keys(topicToPass).map((key) => {
                if (key?.includes("answer") && key !== "answer") {
                  obj.push({ key: key, value: topicToPass[key] });
                }
              });
              topicToPass["answersToLoad"] = obj;
              try {
                const res1 = await get(config.api.url + "getTrialConfig/noOfMaxAttemptsAllowedForAssessment");
                const res2 = await get(config.api.url + "getTrialConfig/messageForAssessmentScoreThreshold");

                if (res1?.data?.value) setMaxAttemptsAssessment(res1.data.value);
                if (res2?.data?.value) setMaxAttemptsAssessmentMessage(res2.data.value);

                if (response.data && response.data.getCompletionRecordsForUserResponse.length > 0) {
                  if (response.data.getCompletionRecordsForUserResponse.length >= parseInt(res1.data.value)) {
                    var allLessonArchievedCount = 0;
                    response.data.getCompletionRecordsForUserResponse.forEach(lesson => {
                      if (lesson && lesson.logid.startsWith('archive-')) {
                        allLessonArchievedCount += 1;
                      }
                    })
                    console.log('allLessonArchievedCount',allLessonArchievedCount)
                    if (allLessonArchievedCount == response.data.getCompletionRecordsForUserResponse.length) {
                      setRetakeFlag(false);
                      setMaxAttemptLimitReached(false);
                    } else {
                      setMaxAttemptLimitReached(true);
                    }
                  } 
                  // else {
                  //   setRetakeFlag(true);
                  // }
                } 
                // else {
                //   setRetakeFlag(true);
                // }
              } catch (err) {
                console.error("Error getting data.", err);
              }
            }
          }
          if (
            viewedLessonData.lessondetails?.lessonlanguages &&
            viewedLessonData.lessondetails?.lessonlanguages?.includes(",")
          ) {
            viewedLessonData.lessondetails["languages"] =
              viewedLessonData.lessondetails.lessonlanguages
                .split(",")
                .map((x) => x.trim());
          }
          settopicToLoad(topicToPass);
          localStorage.setItem("topics", JSON.stringify(lesson.topics));
          localStorage.setItem("lessonid", lessonid);
          setlessonData(viewedLessonData);
        }
      }
    });
  };

  useEffect(() => {
    let lesson_url =
      config.api.url + "getLessonViewDetails?lessonid=" + lessonid;
    if (topicid !== null && topicid !== "") {
      lesson_url = lesson_url + "&topicid=" + topicid;
    }
    lesson_url = lesson_url + "&limit=5";
    // setlessonurl(lesson_url);
    loadLessondata(lesson_url, topicid);
  }, []);

  const onClickTopics = (event) => {
    let topicid = event.target.id;
    setToggleHeader(false);
    loadLessondata(
      config.api.url +
      "getLessonViewDetails?lessonid=" +
      lessonid +
      "&topicid=" +
      topicid +
      "&limit=5",
      topicid
    );
  };

  // Functions to handle next and previous clicks
  const clickNextBtnFunc = () => {
    let topics = JSON.parse(localStorage.getItem("topics"));
    let currentTopic = localStorage.getItem("topicid");
    let indexOfTopic = topics.findIndex((x) => x.topic_id == currentTopic);
    if (
      indexOfTopic != null &&
      indexOfTopic != null &&
      indexOfTopic + 1 >= topics.length - 1
    ) {
      if (
        lessonData?.lessondetails?.lessontype === "regularlesson" &&
        lessonData?.lessondetails?.status === "active"
      ) {
        setAckFlag(true);
      }
    }
    if (
      indexOfTopic != null &&
      indexOfTopic != null &&
      indexOfTopic < topics.length - 1
    ) {
      let topicid = topics[indexOfTopic + 1].topic_id;
      loadLessondata(
        config.api.url +
        "getLessonViewDetails?lessonid=" +
        lessonid +
        "&topicid=" +
        topicid +
        "&limit=5",
        topicid
      );
    }
    if (
      indexOfTopic != null &&
      indexOfTopic != null &&
      indexOfTopic === topics.length - 1
    ) {
      // redirect to acknowledgement page, or show ack not allowed based on review flag
      let topicid = topics[indexOfTopic].topic_id;
      loadLessondata(
        config.api.url +
        "getLessonViewDetails?lessonid=" +
        lessonid +
        "&topicid=" +
        topicid +
        "&limit=5",
        topicid
      );
    }
  };
  const clickPrevBtnFunc = () => {
    let topics = JSON.parse(localStorage.getItem("topics"));
    let currentTopic = localStorage.getItem("topicid");
    let indexOfTopic = topics.findIndex((x) => x.topic_id === currentTopic);
    if (indexOfTopic != null && indexOfTopic != null && indexOfTopic >= 1) {
      let topicid = topics[indexOfTopic - 1].topic_id;
      loadLessondata(
        config.api.url +
        "getLessonViewDetails?lessonid=" +
        lessonid +
        "&topicid=" +
        topicid +
        "&limit=5",
        topicid
      );
    }
  };

  const handleRetakeAction = () => {
    var url = config.api.url + "retakeAssessmentForMe";
    const lessonid = lessonData.lessondetails.lessonid;
    setIsRetakeClicked(true);
    post(url, JSON.stringify({ lessonid: lessonid }))
      .then((result) => {
        let userData = result.data;
        let urlToRedirect = "";
        if (window.location.pathname.includes("lessonviewmobile")) {
          urlToRedirect = "/lessonviewmobile?lessonid=" + lessonid;
        } else if (
          window.location.pathname.includes("lessonviewassessmentmobile")
        ) {
          urlToRedirect = "/lessonviewassessmentmobile?lessonid=" + lessonid;
        } else {
          urlToRedirect = "/lessonview?lessonid=" + lessonid;
        }
        window.location.href = urlToRedirect;
        // navigate(urlToRedirect)
      })
      .catch((err) => {
        console.log("Error in retake assessment api call", err);
      });
  };

  const handleLanguageChange = (language) => {
    let urlToRedirect = "";
    if (window.location.pathname?.includes("lessonviewassessmentmobile")) {
      urlToRedirect =
        "/lessonviewassessmentmobile?lessonid=" +
        lessonid +
        "&language=" +
        language;
    } else if (window.location.pathname?.includes("lessonviewmobile")) {
      urlToRedirect =
        "/lessonviewmobile?lessonid=" + lessonid + "&language=" + language;
    } else {
      urlToRedirect =
        "/lessonview?lessonid=" + lessonid + "&language=" + language;
    }
    window.location.href = urlToRedirect;
  };

  if (lessonData !== null && lessonData !== undefined) {
    return (
      <div className="lessonviewMobilePage app">
        <Header onTrialDUserLoaded={setIsTrialDUser} />
        {/* BREADCRUMB NAVIGATION */}
        <nav
          aria-label="breadcrumb"
          id="mobileNestedlessonBreadcrumb"
          className="pl-2 mr-2 mt-2 mb-2"
        >
          <ol className="breadcrumb breadcrumb-no-gutter" style={{ fontSize: "0.875rem" }}>
            <li className="breadcrumb-item">
              <a
                className="breadcrumb-link"
                href="dashboard"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/dashboard`);
                }}
              >
                Home
              </a>
            </li>
            {parentLessonNames.length > 0 ? (
              parentLessonNames.map((parentName, j) => (
                <li className="breadcrumb-item" key={`breadcrumb-${j}`}>
                  <a
                    className="breadcrumb-link"
                    href={`dashboard?lessonid=${
                      parentLessonIds[j]
                    }&parentids=${parentLessonIds
                      .slice(0, j + 1)
                      .join("|")}&parentNames=${parentLessonNames
                      .slice(0, j + 1)
                      .join("|")}`}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(
                        `/dashboard?lessonid=${
                          parentLessonIds[j]
                        }&parentids=${parentLessonIds
                          .slice(0, j + 1)
                          .join("|")}&parentNames=${parentLessonNames
                          .slice(0, j + 1)
                          .join("|")}`
                      );
                    }}
                  >
                    {parentLessonNames[j]}
                  </a>
                </li>
              ))
            ) : (
              <li className="breadcrumb-item">
                <a className="breadcrumb-link">
                  {lessonData.lessondetails.lessonname}
                </a>
              </li>
            )}
          </ol>
        </nav>
        {/* END BREADCRUMB */}
        <Container
          className={`${lessonData.topics
            .map((topic) =>
              topic.questiontype === "Multiplechoice" ? "p-0" : ""
            )
            .join(" ")}`}
        >
          <Row
            className="m-auto"
            style={
              {
                // backgroundColor: "#fff",
                // boxShadow:
                //   "0 0 0 1px rgba(20, 20, 31, .05), 0 1px 3px 0 rgba(20, 20, 31, .15)",
              }
            }
          >
            <Col col={12} className="p-0 shadow">
              <LessonHeader
                topicToLoad={topicToLoad.topicmedia}
                lessondetails={lessonData.lessondetails}
                isTrialDUser={isTrialDUser}
                handleToggle={handleToggleHeader}
                retakeFlag={retakeFlag}
                maxAttemptLimitReached={maxAttemptLimitReached}
                maxAttemptsAssessmentMessage={maxAttemptsAssessmentMessage}
                ackFlag={ackFlag}
                selectedLanguage={selectedLanguage}
                isAssessment={isAssessment}
                retakeHandler={() => {
                  setRetakeDialogVisible(true);
                }}
                languageChangeHandler={(language) => {
                  handleLanguageChange(language);
                }}
              />

              {/* <Container fluid> */}
              {lessonData.topics.length > 1 ? (
                <div style={{ width: "100%" }}>
                  {!isAssessment && (
                    <Col
                      lg="3"
                      md="3"
                      sm="12"
                      xs="12"
                      style={{ height: "100vh - 70px" }}
                      className="p-0"
                    >
                      <Sidebar
                        isAssessment={isAssessment}
                        topics={lessonData.topics}
                        topicToLoad={topicToLoad}
                        toggle={toggleHeader}
                        lessonid={lessonid}
                        onClickTopics={onClickTopics}
                      />
                    </Col>
                  )}
                  {isAssessment && (
                    <AssessmentProgressBar
                      topics={lessonData.topics}
                      topicToLoad={topicToLoad}
                      lessondetails={lessonData.lessondetails}
                      completionRecord={latestCompletionRecord}
                      allCompletionRecords={allCompletionRecords}
                      maxAttemptLimitReached={maxAttemptLimitReached}
                      maxAttemptsAssessment={maxAttemptsAssessment}
                      maxAttemptsAssessmentMessage={maxAttemptsAssessmentMessage}
                    />
                  )}
                  {Object.keys(topicToLoad).length != 0 ? (
                    <Col lg="9" md="9" sm="12" xs="12" className="p-0">
                      <MediaFrame
                        isAssessment={isAssessment}
                        maxAttemptLimitReached={maxAttemptLimitReached}
                        maxAttemptsAssessmentMessage={maxAttemptsAssessmentMessage}
                        retakeFlag={retakeFlag}
                        topicToLoad={topicToLoad}
                        topics={lessonData.topics}
                        notSetHeight="true"
                        lessonid={lessonid}
                        clickNextBtnFunc={clickNextBtnFunc}
                        clickPrevBtnFunc={clickPrevBtnFunc}
                        selectedLanguage={selectedLanguage}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <Row style={{ width: "100%", margin: "auto" }}>
                  {isAssessment && (
                    <AssessmentProgressBar
                      topics={lessonData.topics}
                      topicToLoad={topicToLoad}
                      lessondetails={lessonData.lessondetails}
                      completionRecord={latestCompletionRecord}
                      allCompletionRecords={allCompletionRecords}
                      maxAttemptLimitReached={maxAttemptLimitReached}
                      maxAttemptsAssessment={maxAttemptsAssessment}
                      maxAttemptsAssessmentMessage={maxAttemptsAssessmentMessage}
                    />
                  )}
                  {Object.keys(topicToLoad).length != 0 ? (
                    <Col lg="12" md="12" sm="12" xs="12" className="p-0">
                      <MediaFrame
                        isAssessment={isAssessment}
                        maxAttemptLimitReached={maxAttemptLimitReached}
                        maxAttemptsAssessmentMessage={maxAttemptsAssessmentMessage}
                        topicToLoad={topicToLoad}
                        topics={lessonData.topics}
                        lessonid={lessonid}
                        notSetHeight="true"
                        clickNextBtnFunc={clickNextBtnFunc}
                        clickPrevBtnFunc={clickPrevBtnFunc}
                        selectedLanguage={selectedLanguage}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              )}
            </Col>
          </Row>
        </Container>
        {/* </Container> */}
        <Dialog
          id="noTopicsDialog"
          header={`No Topics to Display`}
          visible={notTopicsDialogVisible}
          position={"top"}
          style={{ width: "90Vw" }}
          onHide={() => setNoTopicsDialogVisible(false)}
          draggable={false}
          resizable={false}
          dismissable={false}
        >
          <Card className="mt-1">
            <Card.Body className="p-2">
              No active topics are available for this Lesson, please try gain
              later.
            </Card.Body>
          </Card>
        </Dialog>
        <Dialog
          header={`Are you sure?`}
          visible={retakeDialogVisible}
          position={"center"}
          style={{ width: "90Vw" }}
          onHide={() => setRetakeDialogVisible(false)}
          draggable={false}
          resizable={false}
        >
          <p>
            {" "}
            Please note, choosing to retake the assessment will erase your prior
            training record for this lesson. Are you sure you wish to proceed?{" "}
          </p>
          <div className="float-right">
            <button
              type="button"
              className="btn btn-primary mr-2"
              onClick={() => {
                setRetakeDialogVisible(false);
              }}
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              id="retakeAssessmentSure"
              onClick={() => {
                handleRetakeAction();
              }}
              type="button"
              className="btn btn-light"
            >
              <span
                className={`pi pi-spinner pi-spin mr-1 ${isRetakeClicked ? "" : "d-none"
                  }`}
              ></span>
              Retake Assessment
            </button>
          </div>
        </Dialog>
      </div>
    );
  } else {
    return null;
  }
};
export default LessonviewMobile;
